import useGetDiagnosisCategories from '@/hooks/telemedicine/useGetDiagnosisCategories';
import { DiagnosisCategoryInfoModel } from '@/models/diagnosis/category';
import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { BreadCrumb, ROUTES } from '@/types/common';
import { useRouter } from 'next/router';

export interface TelemedicineCategoriesViewModel {
  categoriesInfo: DiagnosisCategoryInfoModel;
  breadCrumbs: BreadCrumb[];
  selectedCategoryType: ECategoryType;
  tabs: {
    type: ECategoryType;
    label: string;
  }[];
}

const tabs: {
  type: ECategoryType;
  label: string;
}[] = [
  {
    type: ECategoryType.Treatment,
    label: '증상',
  },
  { type: ECategoryType.Department, label: '과목' },
];

const useTelemedicineCategoriesViewModel = (): TelemedicineCategoriesViewModel => {
  const router = useRouter();
  const selectedCategoryType = (router.query?.type as ECategoryType) || ECategoryType.Treatment;
  const { categoriesInfo } = useGetDiagnosisCategories();
  const breadCrumbs: BreadCrumb[] = [
    { url: ROUTES.TELEMEDICINE.DOCTORS.path, label: '비대면 진료', logName: 'telemedicine_doctors' },
    { url: ROUTES.TELEMEDICINE.CATEGORIES.path, label: '증상/과목 선택', logName: 'telemedicine_categories' },
  ];
  return {
    selectedCategoryType,
    tabs,
    categoriesInfo,
    breadCrumbs,
  };
};

export default useTelemedicineCategoriesViewModel;
